import { apiClient } from './apiClient';

export const lookupsApi = {
  getGeos: async (): Promise<string[]> => {
    const response = await apiClient.get<string[]>('/lookups/geos');
    return response.data;
  },

  getSectors: async (): Promise<string[]> => {
    const response = await apiClient.get<string[]>('/lookups/sectors');
    return response.data;
  },
};

export default lookupsApi;
